.container {
  min-width: 0;
  width: 90vw;
  max-width: 72rem;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: $bp-small) {
  }
}

.uploader-container {
  width: 100%;
  height: 100%;
}

.options {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.6rem;
}

.options-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
}
